var userAgent = require('../internals/engine-user-agent');

module.exports = /web0s(?!.*chrome)/i.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/engine-is-webos-webkit.js
// module id = 546
// module chunks = 0